import { render, staticRenderFns } from "./Firearm.vue?vue&type=template&id=4a73f641&"
import script from "./Firearm.vue?vue&type=script&lang=ts&"
export * from "./Firearm.vue?vue&type=script&lang=ts&"
import style0 from "./Firearm.vue?vue&type=style&index=0&id=4a73f641&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports